import { Injectable } from '@angular/core';
import { NgOption } from '@ng-select/ng-select';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { IAppConfig } from './settings';

@Injectable({ providedIn: 'root' })
export class SharedConstants {

    private httpClient: HttpClient;
    constructor(handler: HttpBackend) {
        this.httpClient = new HttpClient(handler);
    }

    settingsFile = 'assets/config/settings.json';

    public ApiPort = ':50000';
    public ApiHostName = '';
    public ApiSecretKey;
    public SignalRHostName = 'http://localhost:8083/signalr';

    public roles: NgOption[] = [
        { id: 1, name: 'ADMIN', value: 'ADMIN', valueLogin: 'ADMIN' },
        { id: 2, name: 'USER', value: 'USER', valueLogin: 'USER' },
        { id: 4, name: 'RRHH', value: 'RRHH', valueLogin: 'RRHH' },
        { id: 5, name: 'EXECUTIVE', value: 'EXECUTIVE', valueLogin: 'EXECUTIVE' }
    ];


    public sex: NgOption[] = [
        { id: 1, name: 'Masculino', value: 'H' },
        { id: 2, name: 'Femenino', value: 'M' },
    ];

    public branches: NgOption[] = [
        { id: 0, name: 'Todas' },
        { id: 1, name: 'Sucursal Centro' },
        { id: 2, name: 'Sucursal Sur' },
        { id: 3, name: 'Sucursal Norte' },
    ];

    public mexicoStates: NgOption[] = [
        { id: 1, name: 'Aguascalientes', value: 'AS' },
        { id: 3, name: 'Baja California', value: 'BC' },
        { id: 5, name: 'Baja California Sur', value: 'BS' },
        { id: 7, name: 'Campeche', value: 'CC' },
        { id: 13, name: 'Chiapas', value: 'CS' },
        { id: 15, name: 'Chihuahua', value: 'CH' },
        { id: 17, name: 'CDMX', value: 'CDMX' },
        { id: 9, name: 'Coahuila', value: 'CL' },
        { id: 11, name: 'Colima', value: 'CM' },
        { id: 19, name: 'Durango', value: 'DG' },
        { id: 29, name: 'Estado de México', value: 'MC' },
        { id: 21, name: 'Guanajuato', value: 'GT' },
        { id: 23, name: 'Guerrero', value: 'GR' },
        { id: 25, name: 'Hidalgo', value: 'HG' },
        { id: 27, name: 'Jalisco', value: 'JC' },
        { id: 31, name: 'Michoacán', value: 'MN' },
        { id: 2, name: 'Morelos', value: 'MS' },
        { id: 4, name: 'Nayarit', value: 'NT' },
        { id: 6, name: 'Nuevo León', value: 'NL' },
        { id: 8, name: 'Oaxaca', value: 'OC' },
        { id: 10, name: 'Puebla', value: 'PL' },
        { id: 12, name: 'Querétaro', value: 'QT' },
        { id: 14, name: 'Quintana Roo', value: 'QR' },
        { id: 16, name: 'San Luis Potosí', value: 'SP' },
        { id: 18, name: 'Sinaloa', value: 'SL' },
        { id: 20, name: 'Sonora', value: 'SR' },
        { id: 22, name: 'Tabasco', value: 'TC' },
        { id: 24, name: 'Tamaulipas', value: 'TS' },
        { id: 26, name: 'Tlaxcala', value: 'TL' },
        { id: 28, name: 'Veracruz', value: 'VZ' },
        { id: 30, name: 'Yucatán', value: 'YN' },
        { id: 32, name: 'Zacatecas', value: 'ZS' }
    ];


    public colorPrimary = '#b23d32';
    public colorDark = '#7c020b';
    public colorLight = '#e96d5c';

    public fingerQuality = {
        excelent: '#4db6ac',
        veryGood: '#aed581',
        good: '#fff176',
        poor: '#ffb74d',
        bad: '#e57373'
    };

    public DataTableLanguage = {
        processing: 'Procesando...',
        lengthMenu: 'Mostrar _MENU_ registros',
        zeroRecords: 'No se encontraron resultados con los criterios de búsqueda solicitados.',
        emptyTable: 'No se encontraron registros para visualizar.',
        info: 'Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros',
        infoEmpty: 'Mostrando registros del 0 al 0 de un total de 0 registros',
        infoFiltered: '(filtrado de un total de _MAX_ registros)',
        infoPostFix: '',
        search: 'Buscar:',
        url: '',
        infoThousands: ',',
        loadingRecords: 'Cargando...',
        paginate: {
            first: 'Primero',
            last: 'Ãšltimo',
            next: 'Siguiente',
            previous: 'Atrás'
        },
        aria: {
            sortAscending: ': Activar para ordenar la columna de manera ascendente',
            sortDescending: ': Activar para ordenar la columna de manera descendente'
        }
    };

    public regexPattern = {
        alphanumeric: '^[a-zA-Z0-9ÑñÁáÉéÍíÓóÚúÜü_.,¿?!¡ ]*',
        alphanumeric2: '^[a-zA-Z0-9_-\\s]*',
        alphanumeric3: '^[a-zA-Z0-9_-\\sÑñÁáÉéÍíÓóÚúÜü]*',
        alphanumericTwo: '^[^\\s][a-zA-Z0-9ÑñÁáÉéÍíÓóÚúÜü:.,;\'\"\\s]*',
        numericTwo: '[0-9]{0,7}',
        numeric: '[0-9]+',
        numericThree: '[0-9]{0,5}',
        currency: '^\\$([1-9]{1}[0-9]{0,2}(\\,\\d{3})*(\\.\\d{2})|[1-9]{1}\\d{0,3}(\\.\\d{2})|0(\\.\\d{2}))$|^$',
        prefixPattern: '^(?!noapto|NOAPTO)[a-zA-Z0-9-ÑñÁáÉéÍíÓóÚúÜü_\/]*',
        curp: '^[A-Z]{1}[AEIOUX]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}$',
        //curp2: '^[B-DF-HJ-NP-TV-Z][AEIOU][A-Z]{2}[0-9]{2}(1[0-2]|0[1-9])(3[0-1]|[1-2][0-9]|0[1-9])[H|M][A-Z]{2}[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{2}$', 
        nss: '[0-9]{11}', 
        alphanumericA: '^[^\\s][a-zA-Z0-9ÑñÁáÉéÍíÓóÚúÜü_-\\s]*',
        alphanumericB: '^[^\\s][a-zA-Z0-9ÑñÁáÉéÍíÓóÚúÜü\\s]*',
        //passwordValidator: '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,12}',
        passwordValidator: '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!%*?&])[a-zA-Z0-9@$!%*?&]{8,12}$', 
        emailValidator: "[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$",
        email2Validator: '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$',
        rfc: "/^([A-Z,Ñ,&]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[A-Z|\d]{3})$/",
        rfc2: "^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]?[A-Z,0-9]?[0-9,A-Z]?$",
        OCR: "^[0-9]{13}$",
        onlyNumber: "^(?=.*[0-9])", 
        onlyALetterLowerCase: "^(?=.*[a-z])",
        onlyALetterUpperCase: "^(?=.*[A-Z])",
        onlyAChartEspecial: "^(?=.*[@$!%*?&])",  
        withoutBlankSpace: "^[^\\s]+[\\s\\S]*$",
        //geographicCoordinates:"^([-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)),\s*([-+]?((1[0-7]\d|[1-9]?\d)(\.\d+)?|180(\.0+)?))$",
        geographicCoordinates:"^([-+]?([1-8]?\\d(\\.\\d+)?)),\\s*([-+]?((1[0-7]\\d|[1-9]?\\d)(\\.\\d+)?))$", 
    };

    public messages = {
        serverError: 'Ocurrió un error al intentar conectar con el servidor, favor de intentarlo más tarde.',
        formError: 'Ocurrió un error en el guardado de la información, favor de intentarlo más tarde.',
        editSuceess: 'Se ha realizado exitosamente la actualización de la información.',
        newSuceess: 'Se ha realizado exitosamente el registro de la información.'
    };


    loadApiServer() {
        return new Promise<void>((resolve, reject) => {
            this.httpClient.get(this.settingsFile).toPromise().then((response: IAppConfig) => {
                this.ApiHostName = response.apiServer.apiHostName;
                this.ApiSecretKey = response.apiKey.apiKeyValue;

                localStorage.setItem("urlEmiWeb", response.apiServer.urlEmiWeb);
                this.SignalRHostName = response.apiServer.signalRHostName;
                sessionStorage.setItem("message", response.apiServer.message);
                //localStorage.setItem("messageAbsences", response.apiServer.messageAbsences);
                resolve();
            }).catch((response: any) => {
                reject(`Could not load file '${this.settingsFile}': ${JSON.stringify(response)}`);
            });
        });
    }

    getApiServer(): string {
        if (this.ApiHostName !== '') {
            return this.ApiHostName;
        }
        this.ApiHostName = window.location.protocol + '//' + window.location.hostname + this.ApiPort;
        return this.ApiHostName;
    }
    getApiSecretKey(): string {
        if (this.ApiSecretKey !== '') {
            return this.ApiSecretKey;
        }
    }

    public fingerPosition: any[] = [
        { position: 1, name: 'pulgar derecho', },
        { position: 2, name: 'índice derecho', },
        { position: 3, name: 'medio derecho', },
        { position: 4, name: 'anular derecho', },
        { position: 5, name: 'meñique derecho', },
        { position: 6, name: 'pulgar izquierdo', },
        { position: 7, name: 'índice izquierdo', },
        { position: 8, name: 'medio izquierdo', },
        { position: 9, name: 'anular izquierdo', },
        { position: 10, name: 'meñique izquierdo', },
        { position: 13, name: 'índice, medio, anular y meñique derechos', },
        { position: 14, name: 'índice, medio, anular y meñique izquierdos', },
        { position: 15, name: 'pulgares derecho e izquierdo', },
        { position: 40, name: 'índice y medio derechos', },
        { position: 41, name: 'medio y anular derechos', },
        { position: 42, name: 'anular y meñique derechos', },
        { position: 43, name: 'índice y medio izquierdos', },
        { position: 44, name: 'medio y anular izquierdos', },
        { position: 45, name: 'anular y meñique izquierdos', },
        { position: 46, name: 'índices derecho e izquierdo', },
        { position: 47, name: 'índice, medio y anular derechos', },
        { position: 48, name: 'medio, anular y meñique derechos', },
        { position: 49, name: 'índice, medio y anular izquierdos', },
        { position: 50, name: 'medio, anular y meñique izquierdos', },
    ];


    public msg_default_list: any[] =
        [
            { message_id: 1, message_value: "El registro fue creado con el servicio de deduplicación desactivado por lo tanto no es posible una verificación exitosa para este registro.", keyLg: "common.error403_session" },
            { message_id: 2, message_value: "Usted no cuenta con los permisos necesarios para la pantalla solicitada previamente.", keyLg: "common.error403_session" }
        ];

    public routesDefault = [
        { dashbord: ['list-documents'] },
        { login: ['/login'] }
    ];





}
